import React, { useEffect, useState } from "react";
import { selectCaseStatesLoadingPag, selectCaseStatesPag, selectCaseSubStates } from "../../redux/caseStates/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { AdminTable } from "./AdminTable";
import { createCaseState, deleteCaseState, editCaseState, getCaseStatesPag, getSubStates } from "../../redux/caseStates/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { useTranslation } from "react-i18next";


const initialSortOptions = {
    columna: "stateId",
    sortOrderAsc: true

}

function StatesManagement() { 
    const { t } = useTranslation();
    const states = useSelector(selectCaseStatesPag);
    const subStates = useSelector(selectCaseSubStates);
    const dispatch = useDispatch();
    const loading = useSelector(selectCaseStatesLoadingPag);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    
    const handleCalculateSubStateCellDisplayValue = (rowData) => {
        return rowData.subStates.map(subState => subState.description).join(", ");
    }


    const columnsStates = [
        <Column sortIndex={1} key={"state-1"} dataField="description" caption={t("Description")} />, 
        <Column key={"state-2"} calculateDisplayValue={handleCalculateSubStateCellDisplayValue} dataField={"subStates"} caption={t("Substates")} lookup={{multiple: true, allowClearing: true, dataSource: subStates, displayExpr: "description", valueExpr: "subStateId"}}/>
    ]    

    useEffect(()=>{
        getListCaseStates(mapPageInfo(states));
        dispatch(getSubStates()); 
    },[])

    function mapPageInfo(statesData){
        return {
            pageIndex: statesData.pageIndex ?? 0,
            pageSize: statesData.pageSize ?? 10,
            orderByField:  statesData.columna ?? "stateId",
            orderByAscending:  statesData.sortOrderAsc ?? true
        }
    }

    const getListCaseStates = (pageInfo) => {
        let query= `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getCaseStatesPag({query}));
    }

    function handleSaveNewStateClick(value, closeCreateModal) {    
        const caseStateParams = {body: value}
        dispatch(createCaseState(caseStateParams)).then((data) => {
                if(data.error)
                    dispatch(openModal({ type: "warning", message:data.error.message}))
                else{
                     getListCaseStates(mapPageInfo(states));
                     closeCreateModal()
                    }                    
                })     
    }    

    const handleEditClick = (value, closeEditModal) => {
        const editCaseStateParams ={
                    param: value.stateId,
                    body: value
                }
                dispatch(editCaseState(editCaseStateParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListCaseStates(mapPageInfo(states));
                        closeEditModal();
                    }
                        
                })      
    }

    const handleDeleteClick = (stateId, closeDeleteModal) => {
        dispatch(deleteCaseState({query:stateId})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = states.pageIndex;

                if (states.elements.length === 1) {
                    updatedPageIndex = Math.max(0, states.pageIndex - 1);
                }

                const updatedStates = {
                    ...states,
                    pageIndex: updatedPageIndex,
                };

                getListCaseStates(mapPageInfo(updatedStates));
                closeDeleteModal()            
            }
        })  
    } 

    function allowDelete(rowData){
        return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                sectionTitle={t("State")}
                masterTitle={t("States")}
                itemIdField={"stateId"} 
                itemDescriptionField={"description"} 
                loading={loading} 
                getData={getListCaseStates} 
                dataSource={states} 
                columnasTabla={columnsStates} 
                onCreate={handleSaveNewStateClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                defaultSortField={"stateId"}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
} 
export default StatesManagement;